import {
    Container,
    Typography,
    Box,
    Stack,
    Divider,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
// import MemberImportForm from "../../components/app/member/MemberImportForm";
import BatchFaceIDSetupForm from "../../components/app/member/BatchFaceIDSetupForm";

export default function TestBatchFaceIDSetupForm() {
    const { t } = useTranslation();
    const [value, setValue] = React.useState(1234);

    React.useEffect(() => {
        setValue(1234);
    }, []);

    let lang = getLang();

    let org = {
        id: 129,
        name: "Test Org",
        name_en: "Test Org",
        name_zh: "測試機構",
    };

    // setValue(1234);

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">Test Simple</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                </Box>
                <BatchFaceIDSetupForm orgID={1} />
            </Stack>
        </Container>
    )
}
